export const loginStyles  ={
  loginContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
    backgroundImage: 'url(/static/laundry.png)', // Replace with your image
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
  loginForm: {
    width: 300,
    padding: 20,
    background: "rgba(255, 255, 255, 0.8)",
    borderRadius: 8,
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
  },
  loginFormButton: {
    width: "100%",
  },
}